import React from "react";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "../../widget/streamline-icon/CloseIcon";
import CustomRichText from "../../widget/text/CustomRichText";
import NoIndexDialog from "../noIndex/NoIndexDialog";

const useStyles = makeStyles((theme) => ({
    title: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(5.5)
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1.5),
    },
    content: {
        paddingTop: theme.spacing(0),
        "& h3": {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2)
        },
        "& h4": {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(1.5)
        },
        "& h5": {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(1)
        },
        "& p": {
            marginBottom: theme.spacing(2)
        },
        "& ul": {
            margin: theme.spacing(0),
            paddingLeft: "1.2em",
            "& li": {
                "& p": {
                    marginBottom: theme.spacing(1)
                }
            }
        }
    }
}));

const ResortImportantNotificationDialog = ({title, content, open, onClose, ...props}) => {

    const classes = useStyles();

    const handleClose = () => {
        onClose();
    };

    return (
        <NoIndexDialog
            open={open}
            {...props}
        >
            <DialogTitle
                disableTypography
                className={classes.title}
            >
                <Typography
                    variant={"h3"}
                >
                    {title}
                </Typography>
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={handleClose}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent
                className={classes.content}
            >
                {content &&
                    <CustomRichText
                        document={content}
                    />
                }
            </DialogContent>
        </NoIndexDialog>
    );
};

ResortImportantNotificationDialog.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]).isRequired,
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    props: PropTypes.any
};

export default ResortImportantNotificationDialog;
